import { render } from "./IsoModal.vue?vue&type=template&id=2e67420f"
import script from "./IsoModal.vue?vue&type=script&lang=js"
export * from "./IsoModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__